var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchives(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.37 7.91016L13.37 9.64016L1.24 2.64016L2.24 0.910156L5.28 2.66016L6.64 2.29016L10.97 4.79016L11.34 6.16016L14.37 7.91016ZM0 18.0002V6.00016H5.07L12 10.0002V18.0002C12 18.5306 11.7893 19.0393 11.4142 19.4144C11.0391 19.7894 10.5304 20.0002 10 20.0002H2C1.46957 20.0002 0.960859 19.7894 0.585786 19.4144C0.210714 19.0393 0 18.5306 0 18.0002Z",
    fill: "#E64667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchives);
export default __webpack_public_path__ + "static/media/Archives.1660fbd1216789bb76495989db22e7c2.svg";
export { ForwardRef as ReactComponent };